export default "__VITE_ASSET__BV0kT9GM__"